import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { DeviceSetupInformation } from 'components/DeviceSetupModal/DeviceSetupInformation';
import { hideModal } from 'redux/modules/modals';
import { joinClass } from 'decorators/Bluetooth/bluetooth.saga';
import { userProfile } from 'redux/saga/entities/bound';
import modal from 'decorators/Modal/Modal';
import { DeviceSetupWelcome } from 'components/DeviceSetupModal/DeviceSetupWelcome';
import { updateDevice } from 'redux/modules/video';
import { DeviceSetupTagline } from 'components/DeviceSetupModal/DeviceSetupTagline';
import { DeviceSetupPrepare } from 'components/DeviceSetupModal/DeviceSetupPrepare';
import { DeviceSetupConnection } from 'components/DeviceSetupModal/DeviceSetupConnection';
import { DeviceSetupCast } from 'components/DeviceSetupModal/DeviceSetupCast';
import { DeviceUnsupported } from 'components/DeviceSetupModal/DeviceUnsupported';
import BLUETOOTH_STATUS from 'constants/bluetooth';
import { loadDeviceSetup } from './device-setup-modal.saga';
export var mapStateToProps = function mapStateToProps(state) {
  return {
    alias: state.video.details && state.video.details.alias,
    userProfile: userProfile.data(state),
    device: state.video.device,
    chromecastConnected: state.video.casted
  };
};
export var mapDispatchToProps = {
  hideModal: hideModal,
  joinClass: joinClass,
  loadDeviceSetup: loadDeviceSetup,
  updateDevice: updateDevice
};
export var modalConfig = {
  headerClass: 'modal__device-modal',
  lightClose: true
};
export var DeviceSetupModalUnwrapped =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DeviceSetupModalUnwrapped, _React$Component);

  function DeviceSetupModalUnwrapped(props) {
    var _this;

    _classCallCheck(this, DeviceSetupModalUnwrapped);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DeviceSetupModalUnwrapped).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onUnsupportedPlay", function () {
      _this.onStandardPlay(BLUETOOTH_STATUS.UNSUPPORTED);
    });

    _defineProperty(_assertThisInitialized(_this), "onStandardPlay", function () {
      var deviceStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BLUETOOTH_STATUS.UNINITIALIZED;
      var _this$props = _this.props,
          alias = _this$props.alias,
          localHideModal = _this$props.hideModal,
          localJoinClass = _this$props.joinClass,
          localUpdateDevice = _this$props.updateDevice;

      if (global.BitmovinPlayer) {
        global.BitmovinPlayer.play('ui');
      }

      localUpdateDevice({
        enabled: false,
        status: deviceStatus
      });
      localJoinClass(alias, 'NON_INTERACTIVE');
      localHideModal('DeviceSetupModal');
    });

    _this.state = {
      splash: true
    };
    return _this;
  }

  _createClass(DeviceSetupModalUnwrapped, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props2 = this.props,
          device = _this$props2.device,
          localLoadDeviceSetup = _this$props2.loadDeviceSetup,
          localUpdateDevice = _this$props2.updateDevice,
          localUserProfile = _this$props2.userProfile;

      if (device.status !== BLUETOOTH_STATUS.UNSUPPORTED) {
        localLoadDeviceSetup();
        var profileComplete = localUserProfile && localUserProfile.weight && localUserProfile.weight.kg && localUserProfile.gender && localUserProfile.gender !== 'Unspecified' && localUserProfile.date_of_birth;
        var status = profileComplete ? BLUETOOTH_STATUS.INPUT_TAGLINE : BLUETOOTH_STATUS.INPUT_INFO_WELCOME;
        localUpdateDevice({
          status: status
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        return _this2.setState({
          splash: false
        });
      }, 1000);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props3 = this.props,
          device = _this$props3.device,
          onToggleHide = _this$props3.onToggleHide; // When the native chrome device picker is active, we want to hide our device setup modal.

      var nextStatus = nextProps.device.status;

      if (nextStatus !== device.status) {
        if (nextStatus === BLUETOOTH_STATUS.DEVICE_SELECTION || nextStatus === BLUETOOTH_STATUS.ATTEMPTING_TO_CAST) {
          onToggleHide();
        } else if (device.status === BLUETOOTH_STATUS.DEVICE_SELECTION || device.status === BLUETOOTH_STATUS.ATTEMPTING_TO_CAST) {
          onToggleHide(false);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          alias = _this$props4.alias,
          connectBluetoothDevice = _this$props4.connectBluetoothDevice,
          device = _this$props4.device,
          localHideModal = _this$props4.hideModal,
          localJoinClass = _this$props4.joinClass,
          onToggleHide = _this$props4.onToggleHide,
          localUpdateDevice = _this$props4.updateDevice,
          localUserProfile = _this$props4.userProfile,
          chromecastConnected = _this$props4.chromecastConnected;
      return React.createElement("div", {
        className: "modal__device-setup"
      }, this.state.splash ? React.createElement("div", {
        className: "modal__device-setup__splash anim anim--fadeInOut"
      }, React.createElement("img", {
        src: require('../../../static/img/cp-live-white.svg'),
        alt: "ClassPass Live"
      })) : React.createElement("div", {
        className: "anim anim--fadeIn"
      }, device.status === BLUETOOTH_STATUS.UNSUPPORTED && React.createElement(DeviceUnsupported, {
        handleStandardPlay: this.onUnsupportedPlay
      }), device.status === BLUETOOTH_STATUS.INPUT_INFO_WELCOME && React.createElement(DeviceSetupWelcome, {
        updateDevice: localUpdateDevice
      }), device.status === BLUETOOTH_STATUS.INPUT_INFO && React.createElement(DeviceSetupInformation, {
        userProfile: localUserProfile
      }), device.status === BLUETOOTH_STATUS.INPUT_TAGLINE && React.createElement(DeviceSetupTagline, {
        image: localUserProfile.profile_image_url || require('../../../static/img/icon/avatar.svg'),
        username: localUserProfile.username
      }), device.status === BLUETOOTH_STATUS.PREPARE_WEARABLE && React.createElement(DeviceSetupPrepare, {
        connectBluetoothDevice: connectBluetoothDevice,
        handleStandardPlay: this.onStandardPlay
      }), [BLUETOOTH_STATUS.DEVICE_CONNECTED, BLUETOOTH_STATUS.DEVICE_DISCONNECTED, BLUETOOTH_STATUS.DEVICE_SELECTION, BLUETOOTH_STATUS.DEVICE_FAILED, BLUETOOTH_STATUS.DEVICE_PAIRING_STAGE1, BLUETOOTH_STATUS.DEVICE_PAIRING_STAGE2].indexOf(device.status) > -1 && React.createElement(DeviceSetupConnection, {
        alias: alias,
        inSession: chromecastConnected,
        connectBluetoothDevice: connectBluetoothDevice,
        device: device,
        handleStandardPlay: this.onStandardPlay,
        hideModal: localHideModal,
        updateDevice: localUpdateDevice,
        joinClass: localJoinClass
      }), [BLUETOOTH_STATUS.READY_TO_CAST, BLUETOOTH_STATUS.ATTEMPTING_TO_CAST].indexOf(device.status) > -1 && React.createElement(DeviceSetupCast, {
        alias: alias,
        hideModal: localHideModal,
        onToggleHide: onToggleHide,
        joinClass: localJoinClass,
        status: device.status,
        updateDevice: localUpdateDevice
      })));
    }
  }]);

  return DeviceSetupModalUnwrapped;
}(React.Component);
DeviceSetupModalUnwrapped.propTypes = {
  alias: PropTypes.string,
  chromecastConnected: PropTypes.bool,
  connectBluetoothDevice: PropTypes.func,
  device: PropTypes.object,
  hideModal: PropTypes.func,
  joinClass: PropTypes.func,
  loadDeviceSetup: PropTypes.func,
  onToggleHide: PropTypes.func,
  updateDevice: PropTypes.func,
  userProfile: PropTypes.object
};
export var DeviceSetupModal = connect(mapStateToProps, mapDispatchToProps)(modal(modalConfig)(DeviceSetupModalUnwrapped));